module.exports = __webpack_public_path__ + "img/v7.dcc004f2.png";